module.exports = __webpack_public_path__ + "img/icon-money.f5c00842.svg";